const altacontenidomicrositio = {
    
    AltaDeContenidoMicrositio:'SICPO/AltaDeContenido/AltaDeContenidoMicrositio',
    ContenidosDeMicrositios:'SICPO/AltaDeContenido/GetContenidoMicrositio',
    ModificarOrdenContenidoMicrositio:'SICPO/AltaDeContenido/ModificarOrdenDeContenidosMicrositios'
}

export default altacontenidomicrositio;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/micrositioweb/altadecontenidomicrositio/altacontenidomicrositio.js
// module id = null
// module chunks = 